<div #goUpButtonContainer [hidden]="!showButtonUp" class="go-up-button {{styleClass}}">
  <button type="button"
          class="go-up-button_button"
          (click)="onClickButtonGoUp($event)">
    <i class="{{icon}} go-up-button_button_icon"></i>
  </button>
</div>
